import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76c34d3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mod-versions-card px-4 py-3 mb-3",
  id: "versions"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "fst-semibold mb-3" }, "Архив версий", -1))
const _hoisted_3 = { class: "line mb-3 d-flex justify-content-between" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "me-1 mb-0" }
const _hoisted_6 = { class: "d-flex flex-lg-row flex-column" }
const _hoisted_7 = { class: "ms-1 mb-0" }
const _hoisted_8 = {
  class: "ms-1",
  style: {"color":"#6a6b6f"}
}
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.archive_versions, (row) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(row.version), 1),
          _createTextVNode("— "),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.title), 1),
            _createElementVNode("small", _hoisted_8, "[" + _toDisplayString(row.size) + "]", 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _createTextVNode("загружено " + _toDisplayString(_ctx.getStringTimestamp(row.timestamp)) + " • ", 1),
          _createElementVNode("a", {
            href: "#",
            onClick: _withModifiers(($event: any) => (_ctx.downloadAction(row.id)), ["prevent"]),
            class: "text-decoration-underline"
          }, "Скачать", 8, _hoisted_9)
        ])
      ]))
    }), 256))
  ]))
}